<template>
  <list-expansion
    v-if="obj"
    v-model="obj"
    :components="customComponents"
    :disabled="loading"
    @save-required="$emit('save-required')"
  />
</template>

<script>
import ListExpansion from "@/view/content/fragments/listExpansion.vue";
import { mapState } from "vuex";

export default {
  name: "commercialManager",

  components: { ListExpansion },

  props: {
    value: Object,
    qrId: [Number, String],
    domain: String,
    loading: Boolean,
  },

  data() {
    return {
      obj: {
        cart: {
          fieldFilters: ["table_booking_ability"],
          online_pay: 1,
          card_pay: 1,
          send_by_courier: 1,
          send_by_post: 0,
          in_place: 1,
          table_booking_ability: 1,
          pay_in_person_place: 1,
          free_delivery: 0,
          min_order_cart: 500000,
          max_product_in_order: 30,
          max_order_by_person: 3,
          preparation_time: 30,
          delivery_time: 60,
          send_by_courier_price: 0,
          vat: 10,
        },
        gateways: {
          qr_id: this.qrId,
        },
        reservation: [],
        notice: {
          phones: [{ number: "", id: null }],
        },
      },
    };
  },

  watch: {
    qrId(val) {
      this.obj.gateways.qr_id = val;
    },
  },
  // mounted() {
  //   if (!['qr.menu'].includes(this.$route.name)) {
  //     this.fetchSettings()
  //     this.fetchTables()
  //   }
  // },

  computed: {
    ...mapState("localstorage", ["createQrID", "qrType"]),
    customComponents() {
      return [
        {
          name: "manageAdvertising",
          value: "",
          title: "مدیریت فضای تبلیغاتی",
          subtitle: "",
          icon: "credit-card-settings-outline",
          model: "gateways",
        },
        {
          name: "manageGateways",
          value: "",
          title: "روش‌های پرداخت",
          subtitle: "",
          icon: "credit-card-settings-outline",
          model: "gateways",
        },
        {
          name: "manageDiscounts",
          value: "",
          title: "کد تخفیف",
          subtitle: "",
          icon: "sale-outline",
          model: "discounts",
        },
        {
          name: "orderNotices",
          value: "",
          title: "اطلاع رسانی سفارشات",
          subtitle: "",
          icon: "bell-outline",
          model: "notice",
        },
      ].filter((item) => !!item);
    },
    computedLoading: {
      get() {
        return this.loading;
      },
      set(val) {
        this.$emit("update:loading", val);
      },
    },
  },

  methods: {
    fetchSettings() {
      this.computedLoading = true;

      this.$api
        .get(`/v1/testQr/setting/${this.createQrID}`)
        .then(({ data }) => {
          let cart = {
            ...data.data,
            fieldFilters: [],
          };
          this.handleQrType();
          this.obj.cart = cart;
        })
        .catch(({ response }) =>
          console.log("failed to get qr settings: ", response),
        )
        .finally(() => (this.computedLoading = false));
    },
    fetchTables() {
      this.computedLoading = true;

      this.$api
        .get(`/v1/testQr/table/list/${this.createQrID}`)
        .then(({ data }) => {
          this.obj.reservation = data.data.map((item) => {
            return {
              ...item,
              qr_id: this.createQrID,
            };
          });
        })
        .catch(({ response }) =>
          console.log("failed to get qr settings: ", response),
        )
        .finally(() => (this.computedLoading = false));
    },
    fetchNumbers() {
      this.computedLoading = true;

      this.$api
        .get("/v1/testQr/QrCodeNumber", {
          params: {
            qr_id: this.createQrID,
          },
        })
        .then(
          ({ data }) =>
            (this.obj.notice.phones[0] = {
              number: data?.data[0]?.number,
              id: data?.data[0]?.id,
            }),
        )
        .finally(() => (this.computedLoading = false));
    },
    setCartSetting() {
      return new Promise((resolve, reject) => {
        this.errors = {};
        let obj = this.obj.cart;
        obj.qr_code_id = this.createQrID || 1;

        this.$api
          .post("/v1/testQr/setting", obj)
          .then((data) => {
            resolve("resolved");
          })
          .catch(({ response }) => {
            if (
              !!response?.data?.errors &&
              !!Object.keys(response.data.errors).length
            )
              this.$toast.error("مقادیر را به درستی وارد نمایید!");
            else this.$toast.error("تنظیمات سبد خرید با خطا مواجه شد!");
            reject("rejected");
          });
      });
    },
    setTableReservation() {
      return new Promise((resolve, reject) => {
        this.errors = {};
        let obj = this.obj.reservation;
        // obj.qr_code_id = this.createQrID || 1

        this.$api
          .post("/v1/testQr/table", obj)
          .then((data) => {
            resolve("resolved");
          })
          .catch(({ response }) => {
            if (
              !!response?.data?.errors &&
              !!Object.keys(response.data.errors).length
            )
              this.$toast.error("مقادیر را به درستی وارد نمایید!");
            else this.$toast.error("تنظیمات سبد خرید با خطا مواجه شد!");
            reject("rejected");
          });
      });
    },
    setShopNotice() {
      let number = this.obj.notice.phones[0]?.number;
      let id = this.obj.notice.phones[0]?.id;
      if (!number) return;

      return new Promise((resolve, reject) => {
        this.errors = {};

        this.$api
          .post("/v1/testQr/QrCodeNumber", {
            // qr_code_number_id: this.createQrID,
            number: number,
            qr_code_number_id: id,
            qr_id: this.createQrID,
          })
          .then((data) => {
            resolve("resolved");
          })
          .catch(({ response }) => {
            if (
              !!response?.data?.errors &&
              !!Object.keys(response.data.errors).length
            )
              this.$toast.error("مقادیر را به درستی وارد نمایید!");
            else this.$toast.error("تنظیمات سبد خرید با خطا مواجه شد!");
            reject("rejected");
          });
      });
    },
    handleQrType() {
      if (
        ["bshop", "appointment", "commericial"].includes(
          this.qrType.toLowerCase(),
        )
      ) {
        this.obj.cart.fieldFilters = ["table_booking_ability"];
        this.obj.cart.table_booking_ability = 0;
      }
      if (["commericial"].includes(this.qrType.toLowerCase())) {
        this.obj.cart.fieldFilters.push("manageCart");
      }
    },
  },
};
</script>

<style scoped></style>
